import React from 'react'
import EventItem from './event-item'
import { AnnouncementCardWrapper } from './admin-timetable-event.style'
import { ModuleHeader } from '../module-header'



const TimeTableEvents = ({ search, scroll }) => {
    return (
        <div style={{ marginTop: '3.9rem' }}>
            <ModuleHeader title="SCHOOLS WITH EVENTS THIS MONTH" />
            <AnnouncementCardWrapper scroll={scroll}>
                <EventItem />
                <EventItem />
                <EventItem />
                <EventItem />
                <EventItem />
            </AnnouncementCardWrapper>
        </div>
    )
}

export { TimeTableEvents }
